import {
  requestNoticeList,
  requestNoticeDetail,
} from '@/api/notice';

const state = {
  noticeList: null,
  currentNotice: null,
};

const getters = {
  noticeList: (state) => state.noticeList,
  currentNotice: (state) => state.currentNotice,
};

const actions = {
  async setNoticeList({ commit, dispatch, rootGetters }, { pageNumber, postParams }) {
    const { isLoading } = rootGetters;
    if (isLoading) {
      return;
    }
    await dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestNoticeList({ csrfToken, pageNumber, postParams });
    commit('setNoticeList', result.data);
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    await dispatch('setIsLoading', false, { root: true });
  },
  async setNoticeDetail({ commit, dispatch }, { noticeId }) {
    await dispatch('setIsLoading', true, { root: true });
    const result = await requestNoticeDetail({ noticeId });
    commit('setCurrentNotice', result.data.detail);
    await dispatch('setIsLoading', false, { root: true });
  },
};

const mutations = {
  setNoticeList(state, noticeList) {
    state.noticeList = noticeList;
  },
  setCurrentNotice(state, currentNotice) {
    state.currentNotice = currentNotice;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
